import _ from 'lodash';
import pluralize from 'pluralize';
import Router from './Router';
import ServerRequest from './ServerRequest';

const buildRequest = Symbol('buildRequest');
const getLastPathObject = Symbol('getLastPathObject');
const buildMethodName = Symbol('buildMethodName');
const TYPE_MAPPING = {
  GET: (action) => `get${action}`,
  POST: (action) => `create${pluralize.singular(action)}`,
  PATCH: (action) => `update${pluralize.singular(action)}`,
  PUT: (action) => `update${pluralize.singular(action)}`,
  DELETE: (action) => `destroy${pluralize.singular(action)}`,
  LINK: (action) => `linkTo${action}`
};

export default class RoutesBuilder {
  constructor() {
    this.routesStorage = new Router();
  }

  getRoutes() {
    return this.routesStorage;
  }

  addRoute(path, options = {}) {
    const [, ...pathArray] = path.split('/');
    const pathToSingleResourse = pathArray[pathArray.length - 1][0] === ':';
    const [params, pathParts] = _.partition(pathArray, (part) => part[0] === ':');
    const methodName = this[buildMethodName](pathParts.pop(), options.type, pathToSingleResourse);
    const lastPathObject = this[getLastPathObject](pathParts);

    this.routesStorage.addPathString(path);
    lastPathObject[methodName] = this[buildRequest]({
      path,
      type: options.type,
      pathParams: params,
      bodyParams: options.params
    });
  }

  [buildMethodName](action, httpType, pathToSingleResourse) {
    let name = TYPE_MAPPING[httpType](_.upperFirst(_.camelCase(action)));

    if (((httpType === 'GET') || (httpType === 'LINK')) && pathToSingleResourse) {
      name = pluralize.singular(name);
    }

    return name;
  }

  [buildRequest]({
    path, type, pathParams
  }) {
    return function (requestPathParams = {}, data = {}, dataType = 'json') {
      const realPath = pathParams.reduce((resultPath, param) => {
        const computedParamName = _.camelCase(param.slice(1));
        const value = requestPathParams[computedParamName];
        if (!value) throw Error(`Missing value for url parameter '${computedParamName}' for url ${path}`);

        return resultPath.replace(param, value);
      }, path);

      if (type === 'LINK') {
        if (_.isEmpty(data)) return realPath;

        return _.isString(data) ? `${realPath}?${data}` : `${realPath}?${$.param(data)}`;
      }
      return (new ServerRequest(realPath, dataType))[type.toLowerCase()](data);
    };
  }

  [getLastPathObject](pathParts) {
    return pathParts.reduce((storage, pathPart) => {
      const camelPathPart = _.camelCase(pathPart);

      if (!storage[camelPathPart]) {
        storage[camelPathPart] = {};
      }

      return storage[camelPathPart];
    }, this.routesStorage);
  }
}
